<div>
  <span class="icon-i-sprout"></span>
  <p>{{ kidAccount.owner_name }}</p>
</div>
<span class="icon-i-edit" (click)="onEditName(kidAccount)"></span>
